// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1610":"2c15a4c5","2466":"2c15a4c5","2913":"2c15a4c5","5464":"2c15a4c5","9013":"2c15a4c5"}[chunkId] + ".chunk.css";
};